import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';

const query = gql`
  query {
    indicatorMeasurementTypes {
      name
      dbId
    }
  }
`;

export const useIndicatorMeasurementType = () => {
  const { data: rawData, refetch, loading } = useQuery(query, { fetchPolicy: 'cache-first' });
  const data = (rawData?.indicatorMeasurementTypes || []).map(row => ({ ...row, id: row.dbId }));
  return { data, refetch, loading };
};
